module.exports = __webpack_public_path__ + "img/QRcode.aa851504.png";